import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const evalFormula = (expr, subtotal, rate) => {
  const e = String(expr || "").replace(/×/g, "*").replace(/:/g, "/").replace(/%/g, "/100");
  if (!/^[\d\s+\-*/().,a-z_]*$/i.test(e)) return 0;
  const ids = e.match(/[a-z_]+/gi) || [];
  if (ids.some((x) => !["subtotal", "rate", "min", "max", "round", "abs"].includes(x))) return 0;
  try { const v = Function("subtotal", "rate", "min", "max", "round", "abs", `return (${e});`)(subtotal, rate, Math.min, Math.max, Math.round, Math.abs); return Number.isFinite(v) ? v : 0; } catch { return 0; }
};

export const formulaOk = (expr, rate) => {
  const e = String(expr || "").replace(/×/g, "*").replace(/:/g, "/").replace(/%/g, "/100");
  if (!e.trim() || !/^[\d\s+\-*/().,a-z_]*$/i.test(e)) return false;
  if ((e.match(/[a-z_]+/gi) || []).some((x) => !["subtotal", "rate", "min", "max", "round", "abs"].includes(x))) return false;
  try { return Number.isFinite(Function("subtotal", "rate", "min", "max", "round", "abs", `return (${e});`)(1000000, rate, Math.min, Math.max, Math.round, Math.abs)); } catch { return false; }
};

export const taxAmount = (base, t, manual) => {
  if (!t || base <= 0) return 0;
  if (t.type === "manual") return Math.round(+manual || 0);
  if (t.type === "formula") return Math.round(evalFormula(t.formula, base, +t.rate || 0));
  return Math.round(base * ((+t.rate || 0) * (+t.dpp_num || 1) / (+t.dpp_den || 1)) / 100);
};

const splitTax = (gross, t, manual) => {
  if (!t || gross <= 0) return 0;
  if (t.type === "manual") return Math.round(+manual || 0);
  let lo = 0, hi = gross;
  for (let i = 0; i < 60; i++) { const mid = (lo + hi) / 2; if (mid + taxAmount(mid, t) > gross) hi = mid; else lo = mid; }
  return Math.round(gross - lo);
};

// -> { tax, total }
export const calcTax = (pretax, t, manual) => {
  if (!t) return { tax: 0, total: pretax };
  if (t.mode === "inclusive") return { tax: splitTax(pretax, t, manual), total: pretax };
  const tax = taxAmount(pretax, t, manual);
  return { tax, total: pretax + tax };
};

export const taxLabel = (t) => {
  if (!t) return "Tanpa Pajak";
  const r = t.type === "manual" ? "manual" : `${+t.rate || 0}%`;
  const dpp = t.type === "preset" && +t.dpp_num !== +t.dpp_den ? ` × DPP ${+t.dpp_num}/${+t.dpp_den}` : "";
  return `${t.name} (${r}${dpp} · ${t.mode === "inclusive" ? "termasuk" : "ditambah"})`;
};

export const useTaxes = () => {
  const [v, setV] = useState({ items: [], default_id: "" });
  useEffect(() => { api.get("/settings/taxes").then(({ data }) => setV(data)).catch(() => {}); }, []);
  const find = (id) => (id === "none" ? null : v.items.find((t) => t.id === (id || v.default_id)) || null);
  return { ...v, find };
};
